import { useState, useEffect } from 'react';
import { db } from '@/lib/firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

export const useTransactionNotifications = () => {
    const [pendingCount, setPendingCount] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const q = query(
            collection(db, 'transactionRequests'),
            where('status', '==', 'pending')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setPendingCount(snapshot.docs.length);
            setLoading(false);
        }, (error) => {
            console.error('Error fetching transaction notifications:', error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return { pendingCount, loading };
};
